<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
      <h3>List Item</h3>
      <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
      <div class="d-flex">
        <v-select
        style=" max-width: 150px;"
          :items="option_filter"
          label="Select"
          v-model="searchCategory"
          @change="search=''"
           item-text="text"
          item-value="value"
        
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-text-field
        :disabled="!searchCategory"
        v-model="search"
        label="Search"
          class="ma-2"
        single-line
        hide-details
      >
      </v-text-field>
        <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
    </div>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :options.sync="options"
      :server-items-length="totalDataTable"
      :page="page"
      :pageCount="numberOfPages"
      :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
     > 
    <template v-slot:item="{ item }">
        <tr  @click="onSelect(item)">
            <!-- <td>{{item.spare_part_master_type}}</td> -->
            <td style="width:50mm">{{item.spare_part_price_part_master_code}}</td>
            <td style="width:100mm">{{item.spare_part_price_part_master_name}}</td>
            <td >{{item.spare_part_price_minimum_order_quantity}}</td>
            
            <!-- <td>{{item.spare_part_master_stock}}</td> -->
            <!-- <td>{{item.spare_part_master_unit}}</td> -->
            <td style="width:40mm"><span style="float:left;">Rp.</span><span style="float:right;">{{formatPrice(item.spare_part_price_part_master_unit_price)}}</span></td>
            <!-- <td>{{item.spare_part_master_category}}</td> -->
            <td style="width:40mm"><span style="float:left;">Rp.</span><span style="float:right;">{{formatPrice(item.spare_part_price_part_master_alert_price)}}</span></td>
            <!-- <td style="width:40mm">{{item.spare_part_master_threshold}}</td> -->
            
            
        </tr>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { ResizablePage } from "@/components";

  export default {
    vuetify,
    components: {ResizablePage
  },
     props: {
    data_id: null,
    },
    data () {
      return {
        brand_id: null,
         mounted: true,
        loadTable: false,
        page: 1,
        options: {},
        totalDataTable: 0,
        numberOfPages: 0,
        searchValue:null,
        searchCategory:null,
        search: '',
        headers: [
          // { text: 'Type', value: 'spare_part_master_type' },
          { text: 'Code', value: 'spare_part_master_code' },
          { text: 'Part/Material Name', value: 'spare_part_master_name' },
          { text: 'MOQ', value: 'spare_part_price_minimum_order_quantity' },
          // { text: 'Stok', value: 'spare_part_master_stock' },
          // { text: 'Unit', value: 'spare_part_master_unit' },
          { text: 'Unit Price', value: 'spare_part_master_unit_price' },
          // { text: 'Category', value: 'spare_part_master_category' },
          { text: 'Alert Price', value: 'spare_part_master_name_alert_price' },
          // { text: 'Trace Hold', value: 'spare_part_master_threshold' },
        ],
         option_filter: [ { text: 'Code', value: 'spare_part_master_code' },
          { text: 'Part/Material Name', value: 'spare_part_master_name' },
          ],
        table: [],
      }
    },
    watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    this.mounted = false

    },
    async created() {
      
    // this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() { 

      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };
      // query.filter = { vehicle_status: 3 , vehicle_business_unit: 1};
      // query.filter = { vehicle_business_unit: 1 };
      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      } 

      query.filter = { spare_part_price_dealer_id: this.data_id.dealer_id };
     if (this.searchValue && this.searchCategory) {
           if (query.filter) {
              Object.assign(query.filter, { [this.searchCategory]: this.searchValue});
            } else {
             
              query.filter = { [this.searchCategory]: this.searchValue };
            }
      }

    

    

     

      
      
        //  await this.$store.dispatch("workshop_spare_part_price/list_price_dealer_id", this.data_id.id);
        await this.$store.dispatch("workshop_spare_part_price/list", query);
      this.table = await this.$store.getters["workshop_spare_part_price/list"];
      var pageMeta = await this.$store.getters["workshop_spare_part_price/page"];

      
      
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },

    formatPrice(value) {
      let val = (value/1).toFixed().replace('.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

     searchButton(){
      this.searchValue = this.search
      this.getList()
    },
    clearSearchButton(){
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.getList()
    },


    //fungsi yang ada di parent di panggil saat memilih row di table
    onSelect (item) {
      this.$parent.$parent.$parent.modalCloseListItem(item,this.data_id.index)
      },

      

     },

     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>